import ZariDivider from "../components/ZariDivider";

function Terms_conditions() {
    return (
        <>
            <title>Terms and Conditions | Fashion Freude</title>
            <meta name="title" content="Terms and Conditions | Fashion Freude" />
            <meta
                name="description"
                content="Read the official Terms and Conditions for Fashion Freude. Understand our policies on website use, account registration, orders, pricing, shipping, and returns."
            />
            <meta
                name="keywords"
                content="Fashion Freude terms and conditions, terms of service, user agreement, shopping policy, Fashion Freude terms"
            />
            <meta name="robots" content="index, follow" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <link rel="canonical" href="https://fashionfreude.com/terms-and-conditions" />

            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://fashionfreude.com/terms-and-conditions" />
            <meta property="og:title" content="Terms and Conditions | Fashion Freude" />
            <meta
                property="og:description"
                content="Read the official Terms and Conditions for Fashion Freude. Understand our policies on website use, account registration, orders, and shipping."
            />
            <meta property="og:image" content="https://fashionfreude.com/logo.png" />

            <meta name="twitter:card" content="summary" />
            <meta name="twitter:url" content="https://fashionfreude.com/terms-and-conditions" />
            <meta name="twitter:title" content="Terms and Conditions | Fashion Freude" />
            <meta
                name="twitter:description"
                content="Read the official Terms and Conditions for Fashion Freude. Understand our policies on website use, account registration, orders, and shipping."
            />
            <meta name="twitter:image" content="https://fashionfreude.com/logo.png" />

            <div className="bg-ivory">
                <section className="bg-cream">
                    <div className="container-luxe py-16 text-center">
                        <p className="eyebrow">Please Read Carefully</p>

                        <h1 className="mt-3 font-display text-4xl leading-tight text-ink sm:text-5xl">
                            Terms and Condition
                        </h1>

                        <ZariDivider className="mt-5" />
                    </div>
                </section>

                {/* ==========================================
                TERMS & CONDITIONS CONTENT
            ========================================== */}

                <section className="container-luxe py-14">
                    <div className="mx-auto max-w-3xl">
                        <div className="card p-8 divide-y divide-sand/60">
                            <div className="pb-6 space-y-3 text-muted leading-relaxed">
                                <h3 className="font-display text-2xl text-ink">1. Use of the Website</h3>

                                <p>
                                    You agree to use our site only for lawful purposes and in a way
                                    that does not infringe the rights of others or restrict or
                                    inhibit their use of the website.
                                </p>

                                <p>You must not:</p>

                                <ul className="list-disc space-y-2 pl-6 marker:text-gold">
                                    <li>
                                        Violate any local, national, or international law or
                                        regulation
                                    </li>

                                    <li>
                                        Attempt to gain unauthorized access to the site or any
                                        connected systems
                                    </li>

                                    <li>
                                        Misuse the site by knowingly introducing viruses or other
                                        harmful material
                                    </li>
                                </ul>
                            </div>

                            <div className="py-6 space-y-3 text-muted leading-relaxed">
                                <h3 className="font-display text-2xl text-ink">2. Account Registration</h3>

                                <p>
                                    To access certain features, you may need to register for an
                                    account. You agree to provide accurate, complete information and
                                    to keep your login credentials confidential.
                                </p>

                                <p>
                                    We reserve the right to suspend or terminate accounts that
                                    violate our Terms or contain false or misleading information.
                                </p>
                            </div>

                            <div className="py-6 space-y-3 text-muted leading-relaxed">
                                <h3 className="font-display text-2xl text-ink">3. Product Descriptions & Pricing</h3>

                                <p>
                                    We strive to ensure all product descriptions, images, and prices
                                    are accurate. However, we reserve the right to correct any
                                    errors or omissions and to change or update information without
                                    prior notice.
                                </p>

                                <p>
                                    Prices are listed in [Currency] and are subject to change
                                    without notice. All promotional discounts and offers are subject
                                    to terms and availability.
                                </p>
                            </div>

                            <div className="py-6 space-y-3 text-muted leading-relaxed">
                                <h3 className="font-display text-2xl text-ink">4. Orders & Payment</h3>

                                <p>
                                    By placing an order, you agree to pay the total amount as
                                    indicated at checkout. We accept payments via secure third-party
                                    providers (e.g., Stripe, PayPal, credit/debit cards).
                                </p>

                                <p>We reserve the right to refuse or cancel orders if:</p>

                                <ul className="list-disc space-y-2 pl-6 marker:text-gold">
                                    <li>Products are unavailable</li>

                                    <li>Payment is declined or flagged</li>

                                    <li>We suspect fraudulent activity</li>
                                </ul>
                            </div>

                            <div className="py-6 space-y-3 text-muted leading-relaxed">
                                <h3 className="font-display text-2xl text-ink">5. Shipping & Delivery</h3>

                                <p>
                                    We offer delivery to [Regions/Countries] using trusted shipping
                                    partners. Delivery times are estimates and may vary due to
                                    external factors.
                                </p>

                                <p>
                                    Delays caused by customs, weather, or couriers are beyond our
                                    control, and we are not liable for resulting losses or damages.
                                </p>
                            </div>

                            <div className="py-6 space-y-3 text-muted leading-relaxed">
                                <h3 className="font-display text-2xl text-ink">6. Returns & Refunds</h3>

                                <p>
                                    Please refer to our Return & Refund Policy for full details. In
                                    general:
                                </p>

                                <p>Returns must be requested within [X] days of delivery</p>

                                <p>Items must be unused, in original packaging</p>

                                <p>
                                    Some items (e.g., perishable, personalized, clearance items) may
                                    not be eligible
                                </p>

                                <p>
                                    Refunds are processed to the original payment method within [X]
                                    days after inspection.
                                </p>
                            </div>

                            <div className="py-6 space-y-3 text-muted leading-relaxed">
                                <h3 className="font-display text-2xl text-ink">7. Intellectual Property</h3>

                                <p>
                                    All content on this website—including text, logos, images,
                                    graphics, and software—is the property of [Your Brand Name] and
                                    protected by copyright and trademark laws.
                                </p>

                                <p>
                                    You may not copy, reproduce, distribute, or create derivative
                                    works without our express written permission.
                                </p>
                            </div>

                            <div className="py-6 space-y-3 text-muted leading-relaxed">
                                <h3 className="font-display text-2xl text-ink">8. Limitation of Liability</h3>

                                <p>
                                    To the maximum extent permitted by law, [Your Brand Name] shall
                                    not be liable for any indirect, incidental, special, or
                                    consequential damages arising from the use or inability to use
                                    our website or products.
                                </p>
                            </div>

                            <div className="py-6 space-y-3 text-muted leading-relaxed">
                                <h3 className="font-display text-2xl text-ink">9. Indemnification</h3>

                                <p>
                                    You agree to indemnify, defend, and hold harmless [Your Brand
                                    Name], its affiliates, employees, and agents from any claims,
                                    liabilities, damages, or expenses resulting from your use of the
                                    website or your breach of these Terms.
                                </p>
                            </div>

                            <div className="py-6 space-y-3 text-muted leading-relaxed">
                                <h3 className="font-display text-2xl text-ink">10. Termination</h3>

                                <p>
                                    We reserve the right to suspend or terminate your access to our
                                    website without notice if you violate these Terms or any
                                    applicable law.
                                </p>
                            </div>

                            <div className="py-6 space-y-3 text-muted leading-relaxed">
                                <h3 className="font-display text-2xl text-ink">11. Governing Law</h3>

                                <p>
                                    These Terms shall be governed by and interpreted in accordance
                                    with the laws of [Your Country/State], and any disputes shall be
                                    resolved exclusively in the courts of [Your Jurisdiction].
                                </p>
                            </div>

                            <div className="py-6 space-y-3 text-muted leading-relaxed">
                                <h3 className="font-display text-2xl text-ink">12. Changes to Terms</h3>

                                <p>
                                    We may update these Terms and Conditions from time to time. Any
                                    changes will be posted on this page with a revised “Effective
                                    Date.” Continued use of the site after changes means you accept
                                    the updated Terms.
                                </p>
                            </div>

                            <div className="py-6 space-y-3 text-muted leading-relaxed">
                                <h3 className="font-display text-2xl text-ink">13. Eligibility</h3>

                                <p>
                                    You must be at least 18 years old or the age of majority in your
                                    jurisdiction to use our website. If you are under 18, you may
                                    use our website only with the involvement and consent of a
                                    parent or guardian.
                                </p>
                            </div>

                            <div className="py-6 space-y-3 text-muted leading-relaxed">
                                <h3 className="font-display text-2xl text-ink">14. User Responsibilities</h3>

                                <p>By using our website, you agree to:</p>

                                <ul className="list-disc space-y-2 pl-6 marker:text-gold">
                                    <li>Provide accurate and up-to-date information</li>

                                    <li>Keep your account credentials secure</li>

                                    <li>
                                        Not misuse the website (e.g., spamming, uploading viruses,
                                        hacking, or violating any applicable laws)
                                    </li>

                                    <li>
                                        Use our services for personal, non-commercial purposes
                                        unless we explicitly agree otherwise in writing
                                    </li>
                                </ul>
                            </div>

                            <div className="pt-6 space-y-3 text-muted leading-relaxed">
                                <h3 className="font-display text-2xl text-ink">15. Product Information & Availability</h3>

                                <p>
                                    We make every effort to display product descriptions, pricing,
                                    images, and availability accurately. However, we:
                                </p>

                                <ul className="list-disc space-y-2 pl-6 marker:text-gold">
                                    <li>Reserve the right to correct errors or omissions</li>

                                    <li>May update product details without notice</li>

                                    <li>
                                        Cannot guarantee that colors on your screen match actual
                                        product colors
                                    </li>

                                    <li>
                                        May limit the quantities of any products or services offered
                                    </li>
                                </ul>

                                <p>
                                    All orders are subject to availability. If an item is out of
                                    stock, we will notify you and offer a refund, exchange, or
                                    alternative.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}

export default Terms_conditions;
